import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
    {
        _id: uuid(),
        image: "https://res.cloudinary.com/donqbxlnc/image/upload/v1648516571/fashify/25d7ff1d-6680-4629-b7f8-dda51fb89dc61592396707535-Nautica-Men-Tshirts-3811592396706267-4_hxanis.webp",
        category: "Men",
        rating: "3.9",
        size: "L",
        description: "Men Brown Pure Cotton Polo Collar Pure Cotton T-shirt",
        title: "Louis Philippe Sport",
        trending: false,
        original_price: "1199",
        price: "719",
        delivery_time: "9",
        reviews: "2.9k",
        in_stock: true,
    },
    {
        _id: uuid(),
        title: "Cherry Crumble",
        original_price: "900",
        description:
            "Girls Black Embellished Net & Velvet Finish Fit & Flare Dress",
        price: "499",
        rating: "4.5",
        size: "M",
        image: "https://res.cloudinary.com/donqbxlnc/image/upload/v1648516848/fashify/b33911a2-038f-419a-afd9-e7f7949310441639746739865AllenSollyJuniorBoysMaroonSlimFitCasualShirt1_k5fy77.webp",
        category: "Kids",
        trending: true,
        reviews: "1.5k",
        in_stock: true,
        delivery_time: "3",
    },
    {
        _id: uuid(),
        image: "https://res.cloudinary.com/donqbxlnc/image/upload/v1648516584/fashify/494a0494-2127-485d-8324-28aafe60ca0f1646647959983-one8-x-PUMA-Men-Orange-Brand-Logo-One8Core-Pure-Cotton-Virat-1_vdlx2v.webp",
        category: "Men",
        rating: "3.8",
        size: "S",
        description: "Men Black Printed Henley T-shirt",
        title: "Roadster",
        trending: false,
        original_price: "1199",
        price: "719",
        delivery_time: "6",
        reviews: "2.4k",
        in_stock: true,
    },
    {
        _id: uuid(),
        image: "https://res.cloudinary.com/donqbxlnc/image/upload/v1648516630/fashify/f8e99b19-1b04-4968-828b-5add2713cd541602749203648-W-Women-Kurtas-9021602749202693-1_fglu21.webp",
        category: "Women",
        rating: "4.3",
        size: "L",
        description:
            "Women Off-White & Black Printed Kurta with Palazzos & Dupatta",
        title: "Biba",
        trending: true,
        original_price: "3599",
        price: "1799",
        delivery_time: "8",
        reviews: "605",
        in_stock: false,
    },
    {
        _id: uuid(),
        image: "https://res.cloudinary.com/donqbxlnc/image/upload/v1648516528/fashify/11524206887991-Roadster-Men-Tshirts-9291524206887825-1_djqh04.webp",
        category: "Men",
        rating: "4.2",
        size: "XXL",
        description: "Men Navy Blue Printed Round Neck T-shirt",
        title: "Roadster",
        trending: true,
        original_price: "699",
        price: "384",
        delivery_time: "1",
        reviews: "2.5k",
        in_stock: true,
    },
    {
        _id: uuid(),
        title: "H&M",
        original_price: "899",
        description: "Boys Yellow Printed Cotton Round Neck T-Shirt",
        price: "699",
        rating: "4.1",
        size: "S",
        image: "https://res.cloudinary.com/donqbxlnc/image/upload/v1648516869/fashify/be808931-a165-425b-97b4-7b7806b01c0b1634038540535AllenSollyJuniorBoysSetof2SolidRoundNeckT-shirts1_oxu2ms.webp",
        category: "Kids",
        trending: true,
        reviews: "1.5k",
        in_stock: false,
        delivery_time: "7",
    },
    {
        _id: uuid(),
        image: "https://res.cloudinary.com/donqbxlnc/image/upload/v1648516714/fashify/9e755293-b463-4e4e-8d43-6bec0abbee901628664093230-W-Women-Green-Floral-Printed-Kurta-2771628664092654-1_rhjnye.webp",
        category: "Women",
        rating: "4.3",
        size: "L",
        description:
            "Women Off-White & Black Printed Kurta with Palazzos & Dupatta",
        title: "Bibari",
        trending: true,
        original_price: "3599",
        price: "1799",
        delivery_time: "2",
        reviews: "205",
        in_stock: true,
    },
    {
        _id: uuid(),
        image: "https://res.cloudinary.com/donqbxlnc/image/upload/v1648516553/fashify/1cfd3a7b-1864-4225-b56b-7c129071f4d41635325540976-Nautica-Men-Tshirts-5421635325540510-1_fjgoo2.webp",
        category: "Men",
        rating: "4.3",
        size: "M",
        description:
            "Men Maroon Solid Polo Collar T-shirt with Brand Logo Applique Detail",
        title: "U.S. Polo Assn.",
        trending: false,
        original_price: "1899",
        price: "1234",
        delivery_time: "5",
        reviews: "4k",
        in_stock: true,
    },
    {
        _id: uuid(),
        image: "https://res.cloudinary.com/donqbxlnc/image/upload/v1648516732/fashify/9f7ad33f-e553-4057-8d2a-b5290cf7f6e11608287542552-W-Women-Grey-Zari-Straight-Kurta-3991608287540676-1_fx3fzu.webp",
        category: "Women",
        rating: "4.5",
        size: "L",
        description: "Women Navy Blue & White Printed Straight Kurta",
        title: "anayna",
        trending: false,
        original_price: "1398",
        price: "447",
        delivery_time: "4",
        reviews: "7.9K",
        in_stock: true,
    },
    {
        _id: uuid(),
        title: "HELLCAT",
        original_price: "1599",
        description: "Boys t-shirt and pant",
        price: "1000",
        rating: "3.9",
        size: "M",
        image: "https://res.cloudinary.com/donqbxlnc/image/upload/v1648517072/fashify/153f112a-083f-4164-9a51-7fe0fc5f39471643284835231AllenSollyNavyTShirtandTrackPants1_nuihde.webp",
        category: "Kids",
        trending: true,
        reviews: "1.5k",
        in_stock: true,
        delivery_time: "11",
    },
    {
        _id: uuid(),
        image: "https://res.cloudinary.com/donqbxlnc/image/upload/v1648516456/fashify/f48fa8e4-ee70-4118-8a1d-a898037036bc1527767035968-Roadster-Men-Tshirts-1311527767034405-1_brfgzm.webp",
        category: "Men",
        rating: "4.5",
        size: "M",
        description: "Men White Solid Polo Collar Pure Cotton T-shirt",
        title: "U.S. Polo Assn.",
        trending: false,
        original_price: "1499",
        price: "974",
        delivery_time: "3",
        reviews: "3k",
        in_stock: true,
    },
    {
        _id: uuid(),
        image: "https://res.cloudinary.com/donqbxlnc/image/upload/v1648516665/fashify/7eca68f0-f33e-4b2c-8543-2123d23b76611608026100620-W-Women-Lavender-Pure-Cotton-Yoke-Design-Straight-Kurta-1041-1_blvm0n.webp",
        category: "Women",
        rating: "3.5",
        size: "S",
        description: "Women Yellow Floral Printed Anarkali Kurta",
        title: "Soch",
        trending: false,
        original_price: "1998",
        price: "998",
        delivery_time: "4",
        reviews: "200",
        in_stock: true,
    },
    {
        _id: uuid(),
        image: "https://res.cloudinary.com/donqbxlnc/image/upload/v1648516643/fashify/251c6154-4a45-4afa-b700-267c47eb51741613020264788-3_maquog.webp",
        category: "Women",
        rating: "3.5",
        size: "S",
        description: "Women Yellow Floral Printed Anarkali Kurta",
        title: "Akira",
        trending: false,
        original_price: "1998",
        price: "998",
        delivery_time: "4",
        reviews: "200",
        in_stock: true,
    },
    {
        _id: uuid(),
        title: "Roadster",
        description: "Men Blue Printed Casual Sustainable Shirt",
        original_price: "1499",
        price: "704",
        rating: "4",
        size: "M",
        image: "https://assets.myntassets.com/f_webp,dpr_2.0,q_60,w_210,c_limit,fl_progressive/assets/images/2275365/2022/3/9/c61603b5-1c8d-49ea-887f-9d92378469751646808173028-The-Roadster-Lifestyle-Co-Men-White--Pure-Cotton-T-shirt-551-6.jpg",
        category: "Men",
        trending: false,
        delivery_time: "10",
        reviews: "1000",
        in_stock: false,
    },
    {
        _id: uuid(),
        image: "https://res.cloudinary.com/donqbxlnc/image/upload/v1648516776/fashify/16b43efc-b532-414b-a21a-2ce43b8852541646288746648-W-Women-White--Pink-Printed-Straight-Kurta-361646288746288-1_p31wrb.webp",
        category: "Women",
        rating: "4.2",
        size: "S",
        description: "Women Mauve & White Bandhani Printed Pure Cotton Kurta",
        title: "Varanga",
        trending: true,
        original_price: "1587",
        price: "890",
        delivery_time: "4",
        reviews: "1.9K",
        in_stock: true,
    },
    {
        _id: uuid(),
        title: "KALINI",
        description:
            "Women Teal Yoke Design Kurta with Palazzos & With Dupatta",
        original_price: "3699",
        price: "887",
        rating: "3.8",
        size: "L",
        trending: true,
        delivery_time: "3",
        reviews: "229",
        in_stock: true,
        image: "https://assets.myntassets.com/f_webp,dpr_2.0,q_60,w_210,c_limit,fl_progressive/assets/images/15385296/2021/11/16/c736d7bf-9b5d-48e9-be7d-36aecce835151637061559891-W-Women-Beige--Black-Ethnic-Motifs-Keyhole-Neck-Pastel-Kurta-1.jpg",
        category: "Women",
    },
    {
        _id: uuid(),
        title: "AHIKA",
        description:
            "Women Lavender Embroidered Mirror Work Kurta with Palazzos & With Dupatta",
        original_price: "4248",
        price: "1699",
        rating: "3.2",
        size: "M",
        image: "https://assets.myntassets.com/f_webp,dpr_2.0,q_60,w_210,c_limit,fl_progressive/assets/images/6920472/2020/12/24/43b2f2e4-57b2-40b8-ae45-e263e512329e1608810790479-W-Women-Brown--Navy-Blue-Striped-Straight-Kurta-487160881078-1.jpg",
        category: "Women",
        trending: false,
        reviews: "3k",
        in_stock: true,
        delivery_time: "9",
    },
    {
        _id: uuid(),
        title: "H&M",
        original_price: "1099",
        description: "Boys Blue Printed T-shirt",
        price: "999",
        rating: "4.3",
        size: "L",
        image: "https://res.cloudinary.com/donqbxlnc/image/upload/v1648516936/fashify/67b2f5d2-3064-4389-98e4-8ce05b4c354f1647513608806-Allen-Solly-Junior-Boys-Navy-Blue-Slim-Fit-Geometric-Print-P-1_ecyumj.webp",
        category: "Kids",
        trending: false,
        reviews: "20",
        in_stock: true,
        delivery_time: "11",
    },
    {
        _id: uuid(),
        image: "https://res.cloudinary.com/donqbxlnc/image/upload/v1648516510/fashify/4d2f609d-4ea2-4d5e-a26a-80cd5eb9e4181592396326747-Nautica-Men-Tshirts-8971592396324879-1_zb8w62.webp",
        category: "Men",
        rating: "4.3",
        size: "S",
        description:
            "Men Olive Green Slim Fit Polo Collar Cotton Pure Cotton T-shirt",
        title: "WROGN",
        trending: false,
        original_price: "1599",
        price: "959",
        delivery_time: "2",
        reviews: "5k",
        in_stock: true,
    },
    {
        _id: uuid(),
        image: "https://res.cloudinary.com/donqbxlnc/image/upload/v1648516714/fashify/9e755293-b463-4e4e-8d43-6bec0abbee901628664093230-W-Women-Green-Floral-Printed-Kurta-2771628664092654-1_rhjnye.webp",
        category: "Women",
        rating: "4.2",
        size: "L",
        description:
            "Women Navy Blue Ethnic Motifs Embroidered Thread Work Kurta with Trousers & With Dupatta",
        title: "Anubhutee",
        trending: false,
        original_price: "1587",
        price: "890",
        delivery_time: "9",
        reviews: "956",
        in_stock: false,
    },
    {
        _id: uuid(),
        image: "https://res.cloudinary.com/donqbxlnc/image/upload/v1648516472/fashify/0ecfa52f-1888-49c7-a2da-30e9ef12847a1645512118048Tshirts1_unq0kb.webp",
        category: "Men",
        rating: "4.4",
        size: "L",
        description: "Men Maroon Solid Polo Collar T-shirt",
        title: "Nautica",
        trending: true,
        original_price: "2999",
        price: "1649",
        delivery_time: "5",
        reviews: "2.5k",
        in_stock: true,
    },
    {
        _id: uuid(),
        title: "Mast & Harbour",
        description: "Men Blue & White Slim Fit Striped Casual Shirt",
        original_price: "2099",
        price: "1154",
        rating: "3.9",
        size: "M",
        image: "https://assets.myntassets.com/f_webp,dpr_2.0,q_60,w_210,c_limit,fl_progressive/assets/images/1729391/2019/8/28/a9d4a7aa-af7e-4a37-a9d4-a94dc8c057e81566992341974-WROGN-Navy-Blue-Slim-Fit-Checked-Casual-Shirt-52415669923403-1.jpg",
        category: "Men",
        trending: false,
        reviews: "1.2k",
        in_stock: true,
        delivery_time: "3",
    },
    {
        _id: uuid(),
        title: "Cutiekins",
        original_price: "1099",
        description: "Black Floral Off-Shoulder High Low Crepe Dress",
        price: "619",
        rating: "3.5",
        size: "S",
        image: "https://res.cloudinary.com/donqbxlnc/image/upload/v1648516896/fashify/dce84423-582a-4487-986b-46af90a7048e1647926860775-Allen-Solly-Junior-Girls-Navy-Blue--Off-White-Floral-Print-T-2_d2obqp.jpg",
        category: "Kids",
        trending: false,
        reviews: "134",
        in_stock: true,
        delivery_time: "12",
    },
    {
        _id: uuid(),
        title: "Nautica",
        description: "Men Navy Blue Solid T-shirt",
        original_price: "2399",
        price: "1439",
        rating: "4.3",
        size: "XXL",
        image: "https://assets.myntassets.com/f_webp,dpr_2.0,q_60,w_210,c_limit,fl_progressive/assets/images/7229767/2019/1/31/97d63969-943d-46d3-b9e0-6bf57b6428821548938509728-WROGN-Men-Blue-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jean-1.jpg",
        category: "Men",
        trending: true,
        reviews: "1.4k",
        in_stock: true,
        delivery_time: "5",
    },
    {
        _id: uuid(),
        image: "https://res.cloudinary.com/donqbxlnc/image/upload/v1648516822/fashify/e82d41b2-7dc0-4495-b44d-ea589e4ce4541613970872030-1_vl3otv.webp",
        category: "Women",
        rating: "4.3",
        size: "L",
        description:
            "Beige & Maroon Zari Embroidered Straight Kurta Palazzo With Dupatta Set",
        title: "Indo Era",
        trending: false,
        original_price: "2210",
        price: "1810",
        delivery_time: "10",
        reviews: "1.5k",
        in_stock: true,
    },
    {
        _id: uuid(),
        title: "BonOrganik",
        description: "Boys White Graphic Printed Round-Neck T-shirt",
        original_price: "499",
        price: "299",
        rating: "4.4",
        size: "S",
        image: "https://assets.myntassets.com/f_webp,dpr_2.0,q_60,w_210,c_limit,fl_progressive/assets/images/16185132/2021/11/20/ada5c51c-1895-4735-a1f4-87e3556143ec1637408738569AllenSollyJuniorGirlsBlue2ExtendedSleevesT-shirt1.jpg",
        category: "Kids",
        trending: false,
        reviews: "3.4k",
        in_stock: true,
        delivery_time: "7",
    },
    {
        _id: uuid(),
        image: "https://res.cloudinary.com/donqbxlnc/image/upload/v1648516493/fashify/11522134275641-Mast--Harbour-Men-Navy-Blue-Striped-Round-Neck-T-shirt-4401522134275464-1_uxmjnr.webp",
        category: "Men",
        rating: "4.1",
        size: "XL",
        description: "Men White & Navy Striped Cotton T-shirt",
        title: "Mast & Harbour",
        trending: true,
        original_price: "899",
        price: "494",
        delivery_time: "6",
        reviews: "1k",
        in_stock: false,
    },
    {
        _id: uuid(),
        title: "H&M",
        original_price: "799",
        description: "Boys White & Blue Printed Cotton Round Neck T-Shirt",
        price: "499",
        rating: "4.7",
        size: "M",
        image: "https://assets.myntassets.com/f_webp,dpr_2.0,q_60,w_210,c_limit,fl_progressive/assets/images/16889412/2022/1/20/58599040-86c2-4281-b0aa-4c4b37c3b83f1642681144612AllenSollyJuniorBoysWhiteCasualShirt1.jpg",
        category: "Kids",
        trending: true,
        reviews: "300",
        in_stock: true,
        delivery_time: "3",
    },
    {
        _id: uuid(),
        title: "Dennis Lingo",
        description: "Men Pink Slim Fit Casual Shirt",
        original_price: "1849",
        price: "684",
        rating: "4.1",
        size: "S",
        image: "https://assets.myntassets.com/f_webp,dpr_2.0,q_60,w_210,c_limit,fl_progressive/assets/images/1700830/2019/4/8/3f06fe25-1ce2-4e1e-88e9-7a9d26b4f0bf1554699735416-WROGN-Men-Rust-Red-High-Density-Print-Round-Neck-T-shirt-961-1.jpg",
        category: "Men",
        trending: true,
        reviews: "4.5k",
        in_stock: true,
        delivery_time: "2",
    },
];
